import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const addressColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'address1',
  headerName: 'Address',
  initialHide: true,
};
